import type {
  CrudSearchItem,
  CrudSelectOption,
  CrudTableColumn
} from '@/types/crud-config'
import type { CustomReplyRecord } from './custom-reply.service'

interface SearchConfigContext {
  companyOptions: CrudSelectOption[]
  usedByOptions: CrudSelectOption[]
  optionsLoading: boolean
  onReplyStatusChange: (value: string | number) => void
}

export function createCustomReplySearchItems(
  context: SearchConfigContext
): CrudSearchItem[] {
  return [
    {
      label: '业务员ID',
      prop: 'userId',
      type: 'input',
      clearable: true,
      placeholder: '请输入业务员Id'
    },
    {
      label: '主体',
      prop: 'corPid',
      type: 'select',
      clearable: true,
      placeholder: '请选择主体',
      options: context.companyOptions
    },
    {
      label: '账号名称',
      prop: 'userName',
      type: 'input',
      clearable: true,
      placeholder: '请输入账号名称'
    },
    {
      label: '使用人',
      prop: 'usedBy',
      type: 'select',
      clearable: true,
      loading: context.optionsLoading,
      placeholder: '请选择使用人',
      options: context.usedByOptions
    },
    {
      label: '客户昵称',
      prop: 'nickName',
      type: 'input',
      clearable: true,
      placeholder: '请输入客户昵称'
    },
    {
      label: '回复日期',
      prop: 'timeSlot',
      type: 'dateRange',
      clearable: false,
      disabled: true,
      valueFormat: 'YYYY-MM-DD',
      startPlaceholder: '开始时间',
      endPlaceholder: '结束时间',
      disabledDate: (date) => new Date() < date
    },
    {
      label: '回复状态',
      prop: 'replyStatus',
      type: 'select',
      clearable: true,
      placeholder: '请选择回复状态',
      options: [
        { label: '未回复', value: 0 },
        { label: '已回复', value: 1 }
      ],
      onChange: context.onReplyStatusChange
    },
    {
      label: '未回复时长',
      prop: 'unrepliedStatus',
      type: 'select',
      clearable: true,
      placeholder: '请选择未回复时长',
      disabled: (model) => model.replyStatus !== 0,
      options: [
        { label: '一小时内未回复', value: 0 },
        { label: '超出一小时未回复', value: 1 }
      ]
    }
  ]
}

export const customReplyTableColumns: CrudTableColumn<CustomReplyRecord>[] = [
  { label: '客户昵称', prop: 'uname', minWidth: 80, showOverflowTooltip: true },
  { label: '备注', prop: 'remark', minWidth: 80, showOverflowTooltip: true },
  {
    label: '回复内容',
    prop: 'content',
    minWidth: 100,
    align: 'left',
    showOverflowTooltip: true
  },
  {
    label: '回复时间',
    prop: 'date',
    minWidth: 80,
    sortable: 'custom',
    showOverflowTooltip: true
  },
  {
    label: '主体名称',
    prop: 'corpName',
    minWidth: 80,
    showOverflowTooltip: true
  },
  { label: '账号ID', prop: 'sid', minWidth: 80, showOverflowTooltip: true },
  { label: '账号名称', prop: 'sname', minWidth: 80, showOverflowTooltip: true },
  { label: '使用人', prop: 'usedBy', minWidth: 80, showOverflowTooltip: true },
  {
    label: '所属部门',
    prop: 'deptName',
    minWidth: 80,
    showOverflowTooltip: true
  },
  {
    label: '所属组',
    prop: 'groupName',
    minWidth: 80,
    showOverflowTooltip: true
  },
  {
    label: '业务员回复时长/未回复至今时长',
    prop: 'replyDual',
    slot: 'replyDual',
    minWidth: 120,
    showOverflowTooltip: true
  }
]
